import { Theme } from "@material-ui/core/styles";
import { createStyles, makeStyles } from "@material-ui/styles";
import React, { useState } from "react";
import { CandidateViewModel } from "../../model/CandidateViewModel";
import { GetTranslation } from "../../translations/GetTranslation";
import { getValidDate } from "../../utils/Dates";
import { useIntl } from "react-intl";
import DatePicker from "../common/datePicker/DatePicker";
import PhoneNoTextField from "../common/textField/PhoneNoTextField";
import CustomButton from "../common/buttons/CustomButton";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    form: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      padding: theme.spacing(2),
    },
    button: {
      marginTop: theme.spacing(2),
    },
  })
);

type InvoicePaymentFormProps = {
  me: CandidateViewModel;
  onSubmit: (me: CandidateViewModel) => void;
};

const InvoicePaymentForm: React.FC<InvoicePaymentFormProps> = ({ me, onSubmit }: InvoicePaymentFormProps) => {
  const classes = useStyles();
  const intl = useIntl();
  const [birthDate, setBirthDate] = useState(me.birthdate);
  const [phone, setPhone] = useState(me.phoneNumber);
  const [phoneValid, setPhoneValid] = useState(false);

  const handlePayClicked = () => {
    onSubmit({ ...me, phoneNumber: phone, birthdate: birthDate! });
  };

  return (
    <form className={classes.form}>
      <DatePicker
        disabled={true /* birth date cannot be null or empty string on the database */}
        label={GetTranslation(intl, "person.field.birthDate")}
        value={birthDate ? getValidDate(birthDate) : null}
        onChange={(date: Date | null) => {
          setBirthDate(date as Date);
        }}
        required={true}
        error={!birthDate}
      />
      <PhoneNoTextField
        label={GetTranslation(intl, "person.field.phoneNumber")}
        value={phone ?? ""}
        onChange={(e) => setPhone(e.target.value)}
        onChangeIsValid={(valid) => setPhoneValid(valid)}
        required={true}
        placeholder={GetTranslation(intl, "person.field.phoneNumber.placeholder")}
      ></PhoneNoTextField>
      <CustomButton
        color="primary"
        className={classes.button}
        tooltip={""}
        onClick={handlePayClicked}
        disabled={!birthDate || !phoneValid}
      >
        {GetTranslation(intl, "paymentMethodSelector.form.button")}
      </CustomButton>
    </form>
  );
};

export default InvoicePaymentForm;
